import axios from '@vtblife/axios';
export class QuizService {
    constructor(baseURL = '/api/cms-service-api') {
        this.client = axios.create({ baseURL });
    }
    async createOrUpdateQuizStep(payload) {
        const { data } = await this.client.post('/api/v1/quiz/passing', payload);
        return data;
    }
    async getStatus(params, { useCache }) {
        const cacheKey = `quizStatus_${params.id}`;
        if (useCache) {
            const quizStatus = localStorage.getItem(cacheKey);
            if (quizStatus && quizStatus !== 'not seen') {
                return quizStatus;
            }
        }
        const { data } = await this.client.get('/api/v1/quiz/status', { params });
        if (useCache) {
            localStorage.setItem(cacheKey, data.status);
        }
        return data.status;
    }
    async touchQuiz(payload) {
        const { data } = await this.client.post('/api/v1/quiz/touch', payload);
        return data;
    }
    async closeQuizStep(payload) {
        const { data } = await this.client.post('/api/v1/quiz/close', payload);
        return data;
    }
}
export const quizService = new QuizService();
//# sourceMappingURL=quiz.service.js.map